import React from 'react'

const Home = () => (
  <div>
    <h1>Welcome to the Tornadoes Website!!!</h1>
  </div>
)

export default Home



// WEBPACK FOOTER //
// ./src/components/Home.js